"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StopDrag_exports = {};
__export(StopDrag_exports, {
  default: () => StopDrag_default
});
module.exports = __toCommonJS(StopDrag_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.14453 6.67578L5.03125 7.39844C4.92708 7.46354 4.84245 7.53516 4.77734 7.61328C4.71224 7.69141 4.66667 7.78255 4.64062 7.88672C4.61458 7.99089 4.60807 8.09505 4.62109 8.19922C4.63411 8.29036 4.66667 8.38151 4.71875 8.47266C4.73177 8.4987 4.73828 8.51823 4.73828 8.53125C4.7513 8.54427 4.75781 8.55729 4.75781 8.57031C4.75781 8.58333 4.81641 8.78516 4.93359 9.17578C5.05078 9.55339 5.1875 10.0026 5.34375 10.5234C5.5 11.0443 5.66927 11.5651 5.85156 12.0859C6.02083 12.5938 6.17708 12.9844 6.32031 13.2578C6.46354 13.5703 6.71094 13.9609 7.0625 14.4297C7.42708 14.8984 7.72656 15.25 7.96094 15.4844C8.14323 15.6797 8.3776 15.8294 8.66406 15.9336C8.96354 16.0247 9.29557 16.0703 9.66016 16.0703H12.8047C13.3906 16.0703 13.8984 15.6992 14.3281 14.957C14.7578 14.2018 15.0378 13.6224 15.168 13.2188C15.1549 13.2188 15.2005 12.8542 15.3047 12.125C15.4219 11.3958 15.5065 10.8555 15.5586 10.5039C15.6497 9.85286 15.6693 9.1888 15.6172 8.51172C15.5781 7.82161 15.5586 7.47005 15.5586 7.45703C15.5586 7.22266 15.4805 7.02734 15.3242 6.87109C15.168 6.71484 14.9792 6.63672 14.7578 6.63672C14.5495 6.63672 14.3672 6.71484 14.2109 6.87109C14.0547 7.01432 13.9766 7.19661 13.9766 7.41797V9.83984C13.9766 9.94401 13.9375 10.0352 13.8594 10.1133C13.7812 10.1914 13.6901 10.2305 13.5859 10.2305C13.4818 10.2305 13.3906 10.1914 13.3125 10.1133C13.2344 10.0352 13.1953 9.94401 13.1953 9.83984V5.97266C13.1953 5.7513 13.1172 5.56901 12.9609 5.42578C12.8047 5.26953 12.6224 5.19141 12.4141 5.19141C12.1927 5.19141 12.0039 5.26953 11.8477 5.42578C11.7044 5.56901 11.6328 5.7513 11.6328 5.97266V9.09766C11.6328 9.21484 11.5938 9.3125 11.5156 9.39062C11.4375 9.45573 11.3464 9.48828 11.2422 9.48828C11.125 9.48828 11.0273 9.45573 10.9492 9.39062C10.8841 9.3125 10.8516 9.21484 10.8516 9.09766V5.15234C10.8516 4.93099 10.7734 4.7487 10.6172 4.60547C10.4609 4.44922 10.2721 4.37109 10.0508 4.37109C9.84245 4.37109 9.66016 4.44922 9.50391 4.60547C9.34766 4.7487 9.26953 4.93099 9.26953 5.15234V9.09766C9.26953 9.21484 9.23047 9.3125 9.15234 9.39062C9.07422 9.45573 8.98307 9.48828 8.87891 9.48828C8.77474 9.48828 8.68359 9.45573 8.60547 9.39062C8.52734 9.3125 8.48828 9.21484 8.48828 9.09766V5.97266C8.48828 5.7513 8.41016 5.56901 8.25391 5.42578C8.11068 5.26953 7.92839 5.19141 7.70703 5.19141C7.48568 5.19141 7.29688 5.26953 7.14062 5.42578C6.9974 5.56901 6.92578 5.74479 6.92578 5.95312V9.72266C6.92578 9.82682 6.88672 9.91797 6.80859 9.99609C6.73047 10.0742 6.63932 10.1133 6.53516 10.1133C6.41797 10.1133 6.32031 10.0742 6.24219 9.99609C6.17708 9.91797 6.14453 9.82682 6.14453 9.72266V6.67578ZM12.8047 16.8711H9.66016C9.19141 16.8711 8.75521 16.7995 8.35156 16.6562C7.96094 16.5 7.64193 16.2917 7.39453 16.0312C7.13411 15.7578 6.8151 15.3737 6.4375 14.8789C6.0599 14.3841 5.77995 13.9609 5.59766 13.6094C5.46745 13.3359 5.31771 12.9518 5.14844 12.457C4.97917 11.9753 4.81641 11.4805 4.66016 10.9727C4.50391 10.4648 4.36719 10.0091 4.25 9.60547C4.13281 9.20182 4.05469 8.94141 4.01562 8.82422C3.92448 8.65495 3.86589 8.47266 3.83984 8.27734C3.8138 8.06901 3.82682 7.8737 3.87891 7.69141C3.94401 7.48307 4.03516 7.30078 4.15234 7.14453C4.28255 6.97526 4.4388 6.83854 4.62109 6.73438L6.14453 5.73828C6.20964 5.36068 6.38542 5.04167 6.67188 4.78125C6.97135 4.52083 7.31641 4.39062 7.70703 4.39062C7.86328 4.39062 8.01302 4.41667 8.15625 4.46875C8.3125 4.50781 8.44922 4.57292 8.56641 4.66406C8.67057 4.35156 8.85938 4.09766 9.13281 3.90234C9.40625 3.69401 9.71224 3.58984 10.0508 3.58984C10.4023 3.58984 10.7148 3.69401 10.9883 3.90234C11.2617 4.09766 11.4505 4.35156 11.5547 4.66406C11.6719 4.57292 11.8021 4.50781 11.9453 4.46875C12.1016 4.41667 12.2578 4.39062 12.4141 4.39062C12.8438 4.39062 13.2083 4.54688 13.5078 4.85938C13.8203 5.15885 13.9766 5.52995 13.9766 5.97266V6.05078C14.0938 5.98568 14.2174 5.9401 14.3477 5.91406C14.4779 5.875 14.6146 5.85547 14.7578 5.85547C15.2005 5.85547 15.5716 6.01172 15.8711 6.32422C16.1836 6.6237 16.3398 6.98828 16.3398 7.41797C16.3398 7.43099 16.3594 7.79557 16.3984 8.51172C16.4505 9.21484 16.4245 9.91146 16.3203 10.6016C16.2812 10.9661 16.2031 11.526 16.0859 12.2812C15.9818 13.0234 15.9297 13.3945 15.9297 13.3945C15.9036 13.4466 15.8255 13.6549 15.6953 14.0195C15.5521 14.3841 15.3503 14.7812 15.0898 15.2109C14.8294 15.6276 14.5104 16.0052 14.1328 16.3438C13.7422 16.6953 13.2995 16.8711 12.8047 16.8711Z",
      fill: "currentColor"
    }
  )
);
const SvgStopDrag = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var StopDrag_default = SvgStopDrag;
